import ProsAndCons from 'components/ProductPage/RatingsAndReviews/ProsAndCons/ProsAndCons';
import { withProsAndConsProps } from 'viewModel/productPage/ratingsAndReviews/prosAndCons/withProsAndConsProps';

export default withProsAndConsProps(ProsAndCons);
